import { render, staticRenderFns } from "./Tenant.vue?vue&type=template&id=f4246644"
import script from "./Tenant.vue?vue&type=script&lang=ts"
export * from "./Tenant.vue?vue&type=script&lang=ts"
import style0 from "./Tenant.vue?vue&type=style&index=0&id=f4246644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports